import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import NewsModal from './NewsModal';

export default function NewsChecker() {
  const [news, setNews] = useState([]);
  const [show, setShow] = useState(false);
  const api_url = useSelector((state) => state.API_URL);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token) return;

    fetch(api_url + 'news/unread/', {
      headers: {
        'Authorization': 'JWT ' + token,
        'Content-Type': 'application/json',
      },
    })
      .then((r) => {
        if (!r.ok) return [];
        return r.json();
      })
      .then((data) => {
        if (data && data.length > 0) {
          setNews(data);
          setShow(true);
        }
      })
      .catch(() => {});
  }, [api_url]);

  const handleMarkRead = () => {
    const token = localStorage.getItem('accessToken');
    Promise.all(
      news.map((n) =>
        fetch(api_url + 'news/' + n.id + '/read/', {
          method: 'POST',
          headers: {
            'Authorization': 'JWT ' + token,
            'Content-Type': 'application/json',
          },
        })
      )
    )
      .then(() => {
        setShow(false);
        setNews([]);
      })
      .catch(() => {
        setShow(false);
        setNews([]);
      });
  };

  if (!show) return null;

  return <NewsModal news={news} onMarkRead={handleMarkRead} />;
}
